import { useTranslation } from "react-i18next";

const BookignMessage = (props) => {
    const { t } = useTranslation();

    let alertClassess = ['alert'];

    let message = null;
    if (props.error) {
        alertClassess.push('alert-danger');
        message = (
            <div className={alertClassess.join(' ')}>
                <ul className="errorList">
                    {props.error.map(e => <li key={e}>{e}</li>)}
                </ul>
            </div>
        );
    }
    if (props.booked) {
        alertClassess.push('alert-success');
        message = (
            <div className={alertClassess.join(' ')}>
                {t('booking.form.bookingSuccess')}
            </div>
        );
    }
    return message;
};

export default BookignMessage;